import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AudioCulture.css';

const AudioCulture = () => {
  const navigate = useNavigate();

  return (
    <div className="audio-culture-container">
      {/* Noise Overlay */}
      <div className="paper-grain"></div>
      
      {/* Margin Content (Asymmetric/Editorial) */}
      <div className="vertical-text-right">
        ISSUE NO. 04 / WINTER ARCHIVE / BLISS-2024
      </div>
      <div className="vertical-text-left">
        NATURAL WINE & SONIC CULTURES
      </div>
      
      {/* Top Navigation */}
      <header className="audio-header">
        <div className="flex items-center gap-2" onClick={() => navigate('/Home')} style={{ cursor: 'pointer' }}>
          <span className="material-symbols-outlined text-primary scale-x-[-1]">west</span>
          <span className="text-xs font-bold tracking-[0.2em] uppercase">BACK</span>
        </div>
        <div className="text-xs font-bold tracking-[0.2em] uppercase border-b-2 border-stone-900 dark:border-stone-100 pb-1">
          MENU
        </div>
      </header>
      
      {/* Hero Section */}
      <section className="hero-section">
        <p className="section-label">AUDIO-CULTURE</p>
        <h1 className="hero-title">
          SOUNDS <br/> OF <br/> <span className="not-italic">BLISS</span>
        </h1>
        <div className="divider-line"></div>
      </section>
      
      {/* Playlists List */}
      <main className="playlists-main">
        {/* Item 01 */}
        <article className="playlist-item">
          <div className="playlist-content">
            <span className="playlist-number">01</span>
            <div className="playlist-info">
              <h2 className="playlist-title">
                POST-PUNK <br/> VINYL NIGHT
              </h2>
              <p className="playlist-description">
                A heavy rotation of distorted basslines and cold-wave synths for late-night pét-nat.
              </p>
              <a className="playlist-link" href="#">
                LISTEN ON SPOTIFY
              </a>
            </div>
          </div>
        </article>
        
        {/* Item 02 */}
        <article className="playlist-item playlist-item-offset">
          <div className="playlist-content">
            <span className="playlist-number">02</span>
            <div className="playlist-info">
              <h2 className="playlist-title">
                NATURAL WINE <br/> & AMBIENT
              </h2>
              <p className="playlist-description">
                Ethereal textures and organic loops. Best served chilled in stems.
              </p>
              <a className="playlist-link" href="#">
                LISTEN ON SPOTIFY
              </a>
            </div>
          </div>
        </article>
        
        {/* Item 03 */}
        <article className="playlist-item playlist-item-offset-right">
          <div className="playlist-content">
            <span className="playlist-number">03</span>
            <div className="playlist-info">
              <h2 className="playlist-title">
                DUB & <br/> RESIDUE
              </h2>
              <p className="playlist-description">
                Low-end frequencies for high-acid oranges. Deep resonance for open minds.
              </p>
              <a className="playlist-link" href="#">
                LISTEN ON SPOTIFY
              </a>
            </div>
          </div>
        </article>
        
        {/* Decorative Image / Texture Element */}
        <div className="decorative-image">
          <img 
            alt="Abstract blur of record player and red lights" 
            src="https://lh3.googleusercontent.com/aida-public/AB6AXuAF9YPmAcsoBZlfFlxb68OiEK-xiBNocDQ4RG3-3IN2a4WwLhK4ErNZkoiPsfF9f86dpNcV_Mor8JvrxY2ylLH9m2xJMjGtZne0t8nHE75g-1kyky30cemfRpKI9NFSmmuPWEVVppwfRYeXp_70f5sRdlUBEoyUyoySoHHHEdMMtVuMyFqIazXV-wshQQXhreNkWIhehkTEy0VT_Ss6pKwNmBy8GcNW24ZmbA9OiDp4BWIZYX3xRqTlPaMwXn8nk5HGdYVZL9qEtcG3"
          />
          <div className="image-overlay"></div>
          <div className="image-caption">
            <p className="caption-label">CURRENTLY SPINNING</p>
            <p className="caption-text">ANALOG DRIFT / 042</p>
          </div>
        </div>
      </main>
      
      {/* Footer / Editorial Note */}
      <footer className="audio-footer">
        <div className="footer-content">
          <div className="footer-section">
            <p className="footer-label">EDITORIAL NOTE</p>
            <p className="footer-text">
              BLISS soundtracks are curated monthly by our resident selectors. We believe in the friction between sound and taste. Each playlist is designed to evolve as the bottle breathes.
            </p>
          </div>
          <div className="footer-bottom">
            <div className="footer-copyright">
              ©2024 BLISS CULTURA
            </div>
            <div className="footer-icon">
              <span className="material-symbols-outlined">north_east</span>
            </div>
          </div>
        </div>
      </footer>
      
      {/* Progress Indicator */}
      <div className="progress-indicator">
        <div className="progress-bar"></div>
      </div>
    </div>
  );
};

export default AudioCulture;
